/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { CozeChatEntry, CozeChatScene } from '../ai-query-oidc/types';
import { COZE_CHAT_ENTRY_PATH } from '../ai-query-oidc/constants';
import { getCozeEmbedEnv } from '../ai-query-oidc/config';

export function buildCozeChatUrl(opts: {
  botId: string;
  spaceId: string;
  scene: CozeChatScene;
  entry: CozeChatEntry;
  connectorId?: string;
}): string {
  const env = getCozeEmbedEnv();
  const appOrigin = (env.VITE_ABR_WEBCHAT_URL ?? '').replace(/\/$/, '');
  if (!appOrigin) {
    return '';
  }

  const url = new URL(COZE_CHAT_ENTRY_PATH, appOrigin);
  url.searchParams.set('bot_id', opts.botId);
  url.searchParams.set('space_id', opts.spaceId);
  url.searchParams.set('scene', opts.scene);
  url.searchParams.set('entry', opts.entry);
  if (opts.connectorId) {
    url.searchParams.set('connector_id', opts.connectorId);
  }
  return url.href;
}
